import dayjs, { Dayjs } from 'dayjs'

/**
 * diffTimes() method. - Return minutes/seconds between two dates
 *
 * @param {Dayjs} date1 - The first date
 * @param {Boolean} seconds - Return seconds if true (default false)
 * @param {Dayjs} date2 - The second date (default current datetime)
 * @return {Number}
 */
export const diffTimes = (
    date1: Dayjs,
    seconds = false,
    date2: Dayjs = dayjs()
): number => Math.ceil(date1.diff(date2, seconds ? 's' : 'm'))

/**
 * formatDate() method. - Return date with supplied format
 *
 * @param {String} date
 * @param {String} format - set format, default is "YYYY-MM-DD"
 * @return {String}
 */
export const formatDate = (date: string, format = 'YYYY-MM-DD'): string =>
    dayjs(date).format(format)

/**
 * getRemainingTime() method. - Get the remaining time in minutes from now
 *
 * @param {String} date - The date to compare
 * @return {String}
 */
export const getRemainingTime = (date: string): number => diffTimes(dayjs(date))

/**
 * getRemainingTime() method. - Get the remaining time from now with a specific text format
 *
 * @param {String} date - The date to compare
 * @return {String}
 */
export const getRemainingTimeText = (date: string, wording: string): string => {
    if (getRemainingTime(date) > 60 || getRemainingTime(date) < 0)
        return formatDate(date, 'HH:mm')
    else if (getRemainingTime(date) < 1) return wording
    else return `${diffTimes(dayjs(date))} min`
}

/**
 * isDateValid() method. - Checks if the string is a valid date
 *
 * @param {String} date - The date to check
 * @return {Boolean}
 */
export const isDateValid = (date: string) => !isNaN(new Date(date).getTime())
